export class AlternativeStatusReadModel
{
    Id: number;
    Name: string;
    OrderValue: number;
}